// Utilities for working with localStorage
import { parseBoolean } from './value-parser'

export const getLocalStorageAsBoolean = (
  key: string,
  defaultValue = false,
): boolean => {
  try {
    if (typeof window === 'undefined' || !('localStorage' in window))
      return defaultValue

    const raw = window.localStorage.getItem(key)
    return parseBoolean(raw, defaultValue)
  } catch {
    return defaultValue
  }
}
